import { getAddress, isAddress, type Address } from "viem";

function optionalAddress(name: string): Address | undefined {
  const value = import.meta.env[name] as string | undefined;
  if (!value) return undefined;
  if (!isAddress(value)) throw new Error(`Invalid ${name}: ${value}`);
  return getAddress(value);
}

function readPositiveInteger(name: string, fallback: number): number {
  const value = import.meta.env[name] as string | undefined;
  if (!value) return fallback;
  if (!/^[1-9]\d*$/.test(value)) throw new Error(`Invalid ${name}: ${value}`);
  return Number(value);
}

export const env = {
  chainId: readPositiveInteger("VITE_CHAIN_ID", 56),
  rpcUrl: (import.meta.env.VITE_BSC_RPC_URL as string | undefined) || "https://bsc-dataseed.binance.org/",
  bscscanBase: (import.meta.env.VITE_BSCSCAN_BASE as string | undefined) || "https://bscscan.com",

  // Required for a live dashboard, but missing values must render a UI banner instead of crashing app import.
  holderLpVaultAddress: optionalAddress("VITE_HOLDER_LP_DIVIDEND_VAULT_ADDRESS"),
  lpTimeVaultAddress: optionalAddress("VITE_LP_TIME_DIVIDEND_VAULT_ADDRESS"),
  buybackBurnVaultAddress: optionalAddress("VITE_BUYBACK_BURN_VAULT_ADDRESS"),
  splitVaultAddress: optionalAddress("VITE_SPLIT_VAULT_ADDRESS"),

  // Optional overrides. If absent, use holderLp.taxToken(), holderLp.lpToken(), and lpTime.token().
  tokenAddressOverride: optionalAddress("VITE_TOKEN_ADDRESS"),
  lpPairAddressOverride: optionalAddress("VITE_LP_PAIR_ADDRESS"),

  // Referral rewards feature (Task 5 of the referral plan). Frontend is gated
  // by `referralEnabled`; the API URL is normalized to drop trailing slashes.
  referralEnabled: (import.meta.env.VITE_REFERRAL_ENABLED as string | undefined) === "true",
  referralRouterAddress: optionalAddress("VITE_REFERRAL_ROUTER_ADDRESS"),
  referralApiUrl: ((import.meta.env.VITE_REFERRAL_API_URL as string | undefined) || "").replace(/\/$/, ""),
};

export function missingRequiredContracts() {
  return [
    ["VITE_HOLDER_LP_DIVIDEND_VAULT_ADDRESS", env.holderLpVaultAddress],
    ["VITE_LP_TIME_DIVIDEND_VAULT_ADDRESS", env.lpTimeVaultAddress],
    ["VITE_BUYBACK_BURN_VAULT_ADDRESS", env.buybackBurnVaultAddress],
    ["VITE_SPLIT_VAULT_ADDRESS", env.splitVaultAddress],
  ]
    .filter(([, value]) => !value)
    .map(([name]) => name);
}
